// Map between menu names and paths
// This helps when menuURL is not available in the database

export const menuPathMap: Record<string, string> = {
  'Dashboard': '/dashboard',
  'ChartOfAccounts': '/chart-of-accounts',
  'CostCenters': '/cost-centers',
  'CostCenterReports': '/reports/cost-centers',
  'Budgets': '/budgets',
  'FixedAssets': '/fixed-assets',
  'FixedAssetCapitalMaintenance': '/fixed-assets/capital-maintenance',
  'FixedAssetRoutineMaintenance': '/fixed-assets/routine-maintenance',
  'FixedAssetSales': '/fixed-assets/sales',
  'FixedAssetRoutineExpenses': '/fixed-assets/reports/routine-expenses',
  'Users': '/users',
  'Roles': '/roles',
  'Permissions': '/permissions',
  'PermissionEngine': '/permissions/engine',
  'ActionPermissions': '/permissions/actions',
  'Companies': '/companies',
  'FiscalYears': '/fiscal-years',
  'Branches': '/branches',
  'Stores': '/stores',
  'Items': '/items',
  'Inventory': '/inventory',
  'Invoices': '/invoices',
  'SalesOrders': '/sales-orders',
  'SalesReturns': '/sales-returns',
  'PurchaseOrders': '/purchase-orders',
  'PurchaseInvoices': '/purchase-invoices',
  'LandedCosts': '/landed-costs',
  'PurchaseReturns': '/purchase-returns',
  'OpeningStockInvoices': '/opening-stock-invoices',
  'SmartStockTake': '/inventory/smart-stock-take',
  'Quotations': '/quotations',
  'Customers': '/customers',
  'Vendors': '/vendors',
  'Partners': '/partners',
  'PartnersDashboard': '/partners/dashboard',
  'PartnerOwnership': '/partners/ownership',
  'PartnerCapital': '/partners/capital',
  'ProfitPeriods': '/partners/profit-periods',
  'ProfitDistributions': '/partners/distributions',
  'PartnerReports': '/partners/reports',
  'Taxes': '/taxes',
  'Reports': '/reports',
  'InteractiveAccountStatement': '/reports/interactive-account-statement',
  'VendorAccountStatement': '/reports/vendor-account-statement',
  'Settings': '/settings',
  'Categories': '/categories',
  'ItemsDirectory': '/items-directory',
  'OperationTypes': '/operation-types',
  'Journal': '/journal',
  'POS': '/pos',
  'Currencies': '/currencies',
  'GeneralAttributes': '/general-attributes',
  'PaymentMethods': '/settings/payment-methods',
  'POSInvoiceDesign': '/reports/pos-invoice-design',
  'InvoiceSettings': '/settings/invoice-settings',
  'FormCustomFields': '/settings/form-custom-fields',
  'ItemCustomFields': '/settings/item-custom-fields',
  'DocumentNumbering': '/settings/document-numbering',
  'ViewToReport': '/reports/view-to-report',
  'DynamicReports': '/dynamic-reports',
  'DynamicReportViews': '/dynamic-reports/views',
  'DynamicReportCreate': '/dynamic-reports/new',
  'DetailedSalesReport': '/reports/detailed-sales',
  'Production': '/production/boms',
  'BOMs': '/production/boms',
  'ProductionOrders': '/production/orders',
  'ProductionCostCalculations': '/production/cost-calculations',
  'CustomForms': '/custom-forms',
  'DynamicForms': '/custom-forms',
  'MunicipalityExportToOnline': '/municipality/export-to-online',
  'MunicipalityOnlineSync': '/municipality/online-sync',
  'NewDentalExamination': '/invoices/dental/new',
  'SubscriptionDashboard': '/subscriptions/dashboard',
  'SubscriptionPackages': '/subscriptions/packages',
  'SubscriptionSubscribers': '/subscriptions/subscribers',
  'SubscriptionContracts': '/subscriptions/contracts',
  'SubscriptionInvoices': '/subscriptions/invoices',
  'SubscriptionAlerts': '/subscriptions/alerts',
  'SubscriptionTickets': '/subscriptions/tickets',
  'SubscriptionAutomation': '/subscriptions/automation',
  'SubscriptionReports': '/subscriptions/reports',
  'SubscriptionAudit': '/subscriptions/audit',
  'SqlQuery': '/settings/sql-query',
  'AboutSystem': '/settings/about',
  'SchemaComparison': '/settings/schema-comparison',
  'Updates': '/settings/updates',
  'DeliveryDashboard': '/delivery',
  'DeliveryOrders': '/delivery/orders',
  'DeliveryDispatch': '/delivery/dispatch',
  'DeliveryDriverApp': '/delivery/driver',
  'DeliveryDrivers': '/delivery/drivers',
  'DeliveryVehicles': '/delivery/vehicles',
  'DeliveryZones': '/delivery/zones',
  'DeliverySettlements': '/delivery/settlements',
  'DeliveryReports': '/delivery/reports',
  'DeliverySettings': '/delivery/settings',
  'FuelStationDashboard': '/fuel-station/dashboard',
  'FuelDailyPrices': '/fuel-station/prices',
  'FuelStations': '/fuel-station/stations',
  'FuelMaster': '/fuel-station/master',
  'FuelReadings': '/fuel-station/readings',
  'FuelMeterCapture': '/fuel-meter',
  'FuelDeliveries': '/fuel-station/deliveries',
  'FuelInventory': '/fuel-station/inventory',
  'FuelTankSettlement': '/fuel-station/settlement',
  'FuelDailyClose': '/fuel-station/close',
  'FuelDailySheet': '/fuel-station/daily-sheet',
  'FuelStationCash': '/fuel-station/cash',
  'FuelPrepaidCoupons': '/fuel-station/prepaid-coupons',
  'FuelReports': '/fuel-station/reports',
  'FuelSettings': '/fuel-station/settings',
  'FuelStationOperations': '/fuel-station/operations',
}

export function getPathFromMenuName(menuName: string): string | null {
  return menuPathMap[menuName] || null
}

export function getMenuNameFromPath(path: string): string | null {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  for (const [name, menuPath] of Object.entries(menuPathMap)) {
    if (menuPath === normalizedPath) {
      return name
    }
  }
  return null
}


